/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentState } from './appointmentState';


export interface AppointmentApiModel { 
    id: number;
    employeeAssessmentId: number;
    employerId: number;
    employerName: string;
    employerAlias: string;
    employeeId: number;
    employeeTitleBeforeName: string;
    employeeName: string;
    employeeSurname: string;
    employeeTitleAfterName: string;
    providerName: string;
    plannedDate: string;
    duration: string;
    appointmentStatus: AppointmentState;
    requireSample: boolean;
}
export namespace AppointmentApiModel {
}


